/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var BizFromEnum;

(function (BizFromEnum) {
  BizFromEnum["EMAIL"] = "email";
  BizFromEnum["EMAIL_VIEWED"] = "email_viewed";
})(BizFromEnum || (BizFromEnum = {}));